export enum ETypeValueType {
  TITLE = 'title',
  COMPANY = 'company',
  CONTACT = 'contact',
  CHANNEL = 'channel',
  SOURCE = 'source',
  LEAD_STAGE = 'lead-stage',
  PERSONAL_DOCUMENT = 'personal-document',
  ROLE = 'role',
  CURRENCY = 'currency',
}
export enum ESREditableContactTypes {
  ACT = "ACT",
  GS = "GS",
  HOTEL = "HOTEL",
  TA = "TA",
  TRANSFER = "TRANSFER"
}
export enum ESREditableCompanyTypes {
  ACT = "ACT",
  GS = "GS",
  HOTEL = "HOTEL",
  TC = "TC",
  TRANSFER = "TRANSFER"
}
export interface ISREditableTypes {
  editableContactTypes: ESREditableContactTypes[];
  editableCompanyTypes: ESREditableCompanyTypes[];
}

export interface ITypeValue {
  code: string;
  enabled: boolean;
  value: string;
  order: number;
}

export interface ICodeValue {
  code: string;
  value: string;
}

export interface ICrmLeadStage {
  code: string;
  value: string;
  order: number;
}
